var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icone_whatsapp_negativo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.04,
    height: 35.04,
    viewBox: "0 0 35.04 35.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_238",
    "data-name": "Caminho 238",
    d: "M21.072,12.1A8.46,8.46,0,0,0,12.6,20.572a7.924,7.924,0,0,0,1.645,4.935l-.74,2.879,2.961-.74a8.285,8.285,0,0,0,4.688,1.4,8.46,8.46,0,0,0,8.472-8.472A8.638,8.638,0,0,0,21.072,12.1Zm4.277,12.256a2.137,2.137,0,0,1-1.316.74h-.9a8.1,8.1,0,0,1-4.113-2.221,21.8,21.8,0,0,1-1.727-2.139,4.6,4.6,0,0,1-.823-2.468c0-.74.494-1.974,1.316-2.139a.9.9,0,0,1,1.234.74,5.031,5.031,0,0,0,.411.987,1.525,1.525,0,0,1,.165.576c0,.576-.823.823-.823,1.4,0,.247.165.411.329.658a14.32,14.32,0,0,0,.987,1.152,5.908,5.908,0,0,0,1.645,1.152.616.616,0,0,0,.411.082.628.628,0,0,0,.411-.165c.329-.247.494-.9.987-.9.082,0,.247.082.329.082.329.165.658.329,1.069.576.082.082.247.082.411.165a.821.821,0,0,1,.411.329C26.007,23.369,25.6,24.027,25.349,24.356Z",
    transform: "translate(-3.552 -3.052)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_239",
    "data-name": "Caminho 239",
    d: "M19.12,1.1A17.52,17.52,0,1,0,36.64,18.62,17.534,17.534,0,0,0,19.12,1.1Zm0,27.719a10.955,10.955,0,0,1-4.935-1.234l-5.1,1.234,1.234-4.853A10.561,10.561,0,0,1,8.838,18.7a10.241,10.241,0,0,1,20.481-.082A10.3,10.3,0,0,1,19.12,28.819Z",
    transform: "translate(-1.6 -1.1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.d4e6cf335b5d28fa9cdfe86843222363.svg";
export { ForwardRef as ReactComponent };